import {
  BookCard,
  LiteraryEventCard,
  ReadingProgress,
} from '@/components/acervo';
import { Button } from '@/components/ui/button';

export default function AcervoPreview() {
  return (
    <div className="min-h-screen bg-paper p-10 space-y-10">
      <div className="flex flex-wrap gap-4">
        <Button variant="wine">Levar comigo</Button>
        <Button variant="wine-outline">Saiba mais</Button>
        <Button variant="underline">Ver resenha completa</Button>
        <Button variant="seal" size="seal">
          ♥
        </Button>
      </div>

      <div className="flex gap-6">
        <BookCard
          title="Torto Arado"
          author="Itamar Vieira Junior"
          tag="Edição de Março"
        />
        <BookCard
          title="A Hora da Estrela"
          author="Clarice Lispector"
          tag="Na fila de leitura"
        />
      </div>

      <ReadingProgress
        label="Torto Arado"
        currentPage={187}
        totalPages={340}
        className="w-80"
      />

      <LiteraryEventCard
        date={new Date(2025, 7, 15)}
        title="Sarau — Torto Arado"
        time="19h às 21h"
        location="Espaço Lily, Manaus"
        seatsFilled={18}
        seatsTotal={30}
      />
    </div>
  );
}
